import styled from 'styled-components';

export const SameAsPrimaryContactText = styled.span`
  font-size: 16px;
`;

export const SameAsPrimaryContactWrapper = styled.div`
  margin-top: 30px;
`;
